<template>
  <b-table
    :items="cards"
    :fields="fields"
    :filter="filter"
    sort-by="decks"
    sort-desc
    :sticky-header="stickyHeader"
    no-border-collapse
    class="umdb-cardlist compact-table-sm"
    primary-key="slug"
  >
    <template v-slot:cell(title)="data">
      <router-link :to="{ name: 'UmDbCard', params: { slug: data.item.slug } }">
        {{ data.value }}
      </router-link>
    </template>

    <template v-slot:cell(type)="type">
      <img v-if="type.value === 'attack'" src="@/assets/images/attack.svg" />
      <img
        v-else-if="type.value === 'defence' || type.value === 'defense'"
        src="@/assets/images/defence.svg"
      />
      <img
        v-else-if="type.value === 'versatile'"
        src="@/assets/images/versatile.svg"
      />
      <img
        v-else-if="type.value === 'scheme'"
        src="@/assets/images/scheme.svg"
      />
    </template>

    <template v-slot:cell(effects)="card">
      <p v-if="card.item.basicText">
        {{ card.item.basicText }}
      </p>
      <p v-if="card.item.type !== 'scheme' && card.item.immediateText">
        <strong>Immediately:</strong> {{ card.item.immediateText }}
      </p>
      <p v-if="card.item.type !== 'scheme' && card.item.duringText">
        <strong>During combat:</strong> {{ card.item.duringText }}
      </p>
      <p v-if="card.item.type !== 'scheme' && card.item.afterText">
        <strong>After combat:</strong> {{ card.item.afterText }}
      </p>
    </template>

    <template v-slot:cell(decks)="data">
      <span tabindex="0" :id="$id(data.item.slug)" class="info-tooltip">{{
        data.value
      }}</span>
      <b-popover
        v-if="data.value"
        :key="'popover-' + data.item.slug"
        :target="$id(data.item.slug)"
        triggers="hover focus"
        placement="auto"
        title="Found in:"
      >
        <p v-for="deck in data.item.decks" :key="deck.slug">
          <router-link :to="{ name: 'UmDbDeck', params: { slug: deck.slug } }">
            {{ deck.name }}
          </router-link>
        </p>
      </b-popover>
    </template>
  </b-table>
</template>

<script type="text/javascript">
export default {
  name: "UmDbCardList",
  data() {
    return {
      fields: [
        {
          key: "title",
          isRowHeader: true,
          sortable: true,
        },
        {
          key: "type",
          sortable: true,
          tdClass: (value) => [
            value,
            "card-type",
            "text-right",
            "align-middle",
          ],
          thClass: "vertical",
        },
        {
          key: "value",
          sortable: true,
          sortByFormatted: true,
          tdClass: (value, key, item) => [
            item.type,
            "card-value",
            "align-middle",
          ],
          thClass: "vertical",
          formatter: (value, key, item) =>
            item.type === "scheme" ? null : value,
        },
        {
          key: "effects",
          class: ["effects"],
        },
        {
          key: "decks",
          tdClass: ["text-right"],
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
        },
      ],
    };
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
    filter: {
      type: String,
      default: "",
    },
    stickyHeader: {
      default: false,
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/less/mixins";

.umdb-cardlist {
  .card-type {
    border-radius: 0.5rem 0 0 0.5rem;
    margin-top: 1em;
    padding-right: 0;
  }
  .card-value {
    font-size: 1.5rem;
    font-weight: bold;
    border-radius: 0 0.5rem 0.5rem 0;
  }
  .attack {
    background-color: @attack-red !important;
    color: white;
    img {
      width: 2.1em;
    }
  }

  .defense,
  .defence {
    background-color: @defence-blue !important;
    color: white;
    img {
      width: 1.65em;
    }
  }

  .versatile {
    background-color: @versatile-violet !important;
    color: white;
    img {
      width: 2em;
    }
  }

  .scheme {
    background-color: @scheme-yellow !important;
    color: white;
    img {
      height: 2em;
      margin-right: -0.5em;
    }
  }

  .effects {
    @media (max-width: 768px) {
      min-width: 65vw;
    }
  }
}
</style>
